import empresa from "./empresa";

export default {
  empresa,
};
